import {
  Core_AddressMsg,
  Core_ContactMsg,
  Core_HumanNameMsg,
  Core_LocalizedStringMsg,
  Core_PhoneNumberMsg,
  Core_Sex,
  Core_TimeFrameOfDayMsg,
  Input_Patientportal_PortalFacilityMsg,
  TimeOfDayMsg,
  Timestamp,
} from "../src/generated/graphql";
import { Maybe } from "@graphql-tools/utils/typings/types";
import moment from "moment";
import React from "react";
import Link from "next/link";

// Example usage for sex: formatMessage({ id: getSex(user?.sex) })
export const buildFullName = (
  humanName: Maybe<Core_HumanNameMsg> | undefined,
  salutation?: Maybe<string>,
): string => {
  let ret: string[] = [];

  if (salutation) {
    ret.push(salutation);
  }
  if (humanName?.title) {
    ret.push(humanName.title);
  }
  if (humanName?.firstName) {
    ret.push(humanName.firstName);
  }

  if (humanName?.middleNames && humanName.middleNames.length > 0) {
    ret.concat(humanName.middleNames?.map((name) => name!));
  }

  if (humanName?.lastName) {
    ret.push(humanName.lastName);
  }

  return ret.length > 0 ? ret.join(" ") : "-";
};

// TODO cleanup, catch edge cases
export const buildAddress = (
  address: Maybe<Core_AddressMsg> | undefined,
  short?: boolean,
): string => {
  let ret = "";

  if (address?.street) {
    ret += address.street;
  }

  if (address?.houseNumber) {
    ret += " " + address.houseNumber;
  }

  if (address?.zipCode) {
    ret += ", " + address.zipCode;
  }

  if (!short && address?.city) {
    ret += " " + address.city;
  }

  return ret.length > 0 ? ret : "-";
};

// TODO cleanup, catch edge cases
export const buildPhoneNumber = (
  number: Maybe<Core_PhoneNumberMsg> | undefined,
): string => {
  let ret = "";

  if (number?.countryCode) {
    ret += `+${number.countryCode}`;
  }

  if (number?.number) {
    ret += " " + number.number;
  }

  return ret;
};

export const buildTimestampDate = (
  timestamp: Maybe<Timestamp> | undefined,
): string => {
  if (!!timestamp?.seconds) {
    return moment(new Date(timestamp.seconds * 1000)).format("DD.MM.YYYY");
  }
  return "-";
};

export const buildTimestampTime = (
  timestamp: Maybe<Timestamp> | undefined,
): string => {
  if (timestamp?.seconds) {
    return moment(new Date(timestamp.seconds * 1000)).format("HH:mm");
  }
  return "-";
};

export const buildTimestampDateTime = (
  timestamp: Maybe<Timestamp> | undefined,
): string => {
  if (timestamp?.seconds) {
    return moment(timestamp.seconds * 1000).format("DD.MM.YYYY HH:mm");
  }
  return "-";
};

function formatTimeOfDay(value?: Maybe<TimeOfDayMsg>): string | undefined {
  if (!value) {
    return undefined;
  }

  const minuteString =
    ((value.minutes && value.minutes < 10) || value?.minutes === 0) &&
    value.hours !== undefined &&
    value.hours !== null
      ? `0${value.minutes}`
      : value?.minutes;
  const hoursString =
    (value.hours && value?.hours < 10) || value?.hours === 0
      ? `0${value.hours}`
      : value?.hours;

  return `${hoursString}:${minuteString}`;
}

export const formatTimeFrame = (
  timeframe: Maybe<Core_TimeFrameOfDayMsg>,
): string => {
  const start = timeframe?.start;
  const end = timeframe?.end;

  return `${formatTimeOfDay(start)} - ${formatTimeOfDay(end)}`;
};

export const extractTranslation = (
  localizedString: Maybe<Core_LocalizedStringMsg> | undefined,
  locale: string | undefined,
): string | undefined =>
  localizedString?.translations?.find(
    (translation) =>
      translation?.locale === "de" || translation?.locale === "de-DE",
  )?.text || undefined;

export const formatPortalFacilityPath = (
  portalFacilityPath: Maybe<
    (Maybe<Input_Patientportal_PortalFacilityMsg> | undefined)[]
  >,
  links?: boolean,
): React.ReactNode | undefined => (
  <span>
    {portalFacilityPath?.map((facility, index) => (
      <span key={facility?.id}>
        {links ? (
          <Link href={`/facility-selection?facilityId=${facility!.id!}`}>
            {facility?.name}
          </Link>
        ) : (
          facility?.name
        )}
        {index < portalFacilityPath.length - 1 && <span> {"/"} </span>}
      </span>
    ))}
  </span>
);

export const getSex = (sex?: Maybe<Core_Sex>) => {
  switch (sex) {
    case Core_Sex.SexM:
      return "signup.prefix.mr";
    case Core_Sex.SexW:
      return "signup.prefix.ms";
    default:
      return " ";
  }
};
